// extracted by mini-css-extract-plugin
export default {"wrap":"rG-z","subtitle":"sG-z","contentWrap":"tG-z","imgWrap":"uG-z","heading":"vG-z","copy":"wG-z"};